import * as log from "loglevel";
import {forEach, find} from "lodash";
import {updatePlayer, playerSprite, performObstacleHit} from "../sprites/player/Player";
import {game} from "../GameCore";
import {levelGroup, updateLevel, levelSprites} from "../level/Level";
import {groundSprites, groundSprite} from "../level/ground/Ground";
import {platformSprites, toggleSwitch} from "../level/platforms/Platforms";
import {IPlatformTile} from 'power-patrol';
import {getGameManager} from '../GameManager';
import {powerUpSprites, collectPowerUp, updatePowerUps} from '../level/power-ups/PowerUps';
import {updateBackground} from '../level/backgrounds/Backgrounds';
import {gameState} from '../config/GameState';
import {updateObstacles, obstacleSprites, hitObstacle} from '../level/ground/Obstacles';
import {playSound} from '../audio/AudioManager';


/**
 * run the game update loop
 * @param phaserGame
 */
export function updateGame()
{
    //  player vs power-ups; only detect if the player is in control

    if (gameState.player.isControllable)
    {
        forEach(powerUpSprites, (sprite: Phaser.Sprite) =>
        {
            //  hard to detect hits on switches within platforms;
            //  let's look for touching-up events and then see if a switch is within range

            if (game.physics.arcade.collide(playerSprite, sprite, function() { return false; }))
            {
                collectPowerUp(sprite);
            }
        });

        forEach(obstacleSprites, (sprite: Phaser.Sprite) =>
        {
            //  hard to detect hits on switches within platforms;
            //  let's look for touching-up events and then see if a switch is within range

            if (game.physics.arcade.collide(playerSprite, sprite, function() { return false; }))
            {
                hitObstacle(sprite);
                performObstacleHit();

                //  play a button sound

                playSound('hit-obstacle');
            }
        });
    }

    playerSprite.body.touching.up = false;
    playerSprite.body.touching.down = false;

    //  collide all the various game elements

    forEach(groundSprites, (sprite: Phaser.Sprite) =>
    {
        game.physics.arcade.collide(playerSprite, sprite);
    });

    forEach(platformSprites, (sprite: IPlatformTile) =>
    {
        //  hard to detect hits on switches within platforms;
        //  let's look for touching-up events and then see if a switch is within range

        game.physics.arcade.collide(playerSprite, sprite);
    });

    if (playerSprite.body.touching.up)
    {
        //  has the player hit a switch?

        hasHitSwitch();
    }

    //  update the background

    updateBackground();

    //  update the player

    updatePlayer();

    //  update the level

    updateLevel();

    //  update the level

    updatePowerUps();
    updateObstacles();

    //  update score

    if (gameState.player.isControllable) getGameManager().incrementScore(1);
}


/**
 * test whether the player has jumped into a switch;
 * if so, turn it off and increase their score
 */
function hasHitSwitch()
{
    var distance: number;

    find(platformSprites, (switchSprite: IPlatformTile) =>
    {
        if ( ! switchSprite.isSwitch || ! switchSprite.isSwitchedOn) return;

        //  hard to detect hits on switches within platforms;
        //  let's look for touching-up events and then see if a switch is within range

        distance = Phaser.Math.distance(switchSprite.body.x, switchSprite.body.y, playerSprite.body.x, playerSprite.body.y)

        //  check the distance; if it's too far ignore the collision

        if (distance > 96) return;

        //  but if we're close enough then toggle the switch

        toggleSwitch(switchSprite);
    });
}


// WEBPACK FOOTER //
// ./src/ts/game/update/Update.ts